import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { Wizard } from '../WizardsDrawer/WizardsDrawerV4/Types'
import { AspectRatioKey, DesignChannels } from 'components/NewFileModal/Types'
import { flowA2Schemas, flowBSchemas, flowCSchemas } from '../schemas/desktopSchemas'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const useIsDesktopWizardFlow = (type: Wizard) => {
  const flowA2Enabled = useFlipperFlag('social_desktop_wizards_flow_A2')
  const flowBEnabled = useFlipperFlag('social_desktop_wizards_flow_B')
  const flowCEnabled = useFlipperFlag('social_desktop_wizards_flow_C')
  const { isMobile } = useResponsiveDesign()
  const contentType = DesignChannels[type as AspectRatioKey]
  const isA2 = Object.keys(flowA2Schemas).includes(contentType)
  const isB = Object.keys(flowBSchemas).includes(contentType)
  const isC = Object.keys(flowCSchemas).includes(contentType)

  if (isMobile) {
    return false
  }

  if (isA2 && flowA2Enabled) return true
  if (isB && flowBEnabled) return true
  if (isC && flowCEnabled) return true

  return false
}
